import React, { useCallback } from 'react'
import { FieldProps, getIn } from 'utils-next/forms'

import { Select, SelectProps } from '../../Inputs/Select'

export type SelectFieldProps = SelectProps & FieldProps

export function SelectField({ field, form: { errors, setFieldValue }, ...props }: SelectFieldProps) {
  const handleChange = useCallback((value: any) => setFieldValue(field.name, value), [field.name, setFieldValue])
  const errorMessage = getIn(errors, field.name)
  return <Select {...field} {...props} onChange={handleChange} error={errorMessage} />
}
